module.exports = __webpack_public_path__ + "img/footer.390ce47f.png";